import React, { useState, useEffect } from 'react';
import { isTouchDevice, isFullscreen, fullscreenSupported, enterFullscreen } from '../utils/fullscreen';

// On touch devices, offer to go fullscreen (and lock to landscape). The prompt
// comes back if the player leaves fullscreen, unless they chose to play windowed.
function FullscreenPrompt() {
  const [fullscreen, setFullscreen] = useState(isFullscreen());
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onChange = () => setFullscreen(isFullscreen());
    document.addEventListener('fullscreenchange', onChange);
    document.addEventListener('webkitfullscreenchange', onChange);
    return () => {
      document.removeEventListener('fullscreenchange', onChange);
      document.removeEventListener('webkitfullscreenchange', onChange);
    };
  }, []);

  if (fullscreen || dismissed || !isTouchDevice() || !fullscreenSupported()) {
    return null;
  }

  return (
    <div id="fullscreenPrompt">
      <div className="fullscreen-button" onClick={enterFullscreen}>TAP TO PLAY FULLSCREEN</div>
      <div className="fullscreen-skip" onClick={() => setDismissed(true)}>Continue in the browser window</div>
    </div>
  );
}

export default FullscreenPrompt;
